import { render, staticRenderFns } from "./GroupFiliation.vue?vue&type=template&id=07d7afb8&"
import script from "./GroupFiliation.vue?vue&type=script&lang=js&"
export * from "./GroupFiliation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports